import { render, staticRenderFns } from "./OptionCard.vue?vue&type=template&id=c629e188&scoped=true"
import script from "./OptionCard.vue?vue&type=script&lang=js"
export * from "./OptionCard.vue?vue&type=script&lang=js"
import style0 from "./OptionCard.vue?vue&type=style&index=0&id=c629e188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c629e188",
  null
  
)

export default component.exports